import {
  NoResponse,
  NotificationSubscribeRequest,
} from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { NOTIFICATIONS_BY_USER } from "~/constants";

import { useNotificationsApi } from "./api";

export function useFcmSubscribe(
  options?: UseMutationOptions<
    AxiosResponse<NoResponse>,
    unknown,
    NotificationSubscribeRequest
  >
) {
  const api = useNotificationsApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((rq) => api.fcmSubscribe(rq), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries([NOTIFICATIONS_BY_USER]);
    },
    ...rest,
  });
}
